import {AccessibilityErrorFilled} from "@fluentui/react-icons";
import {Column, Row} from "./Layout";
import {getCurrentSubDomain} from "../../HomePage";
import {Image} from "@fluentui/react-components";
import successIcon from "../../../assets/ver3/nbt/success.png"
import {useCommonPageStyles} from "../../../styles/mission/commonStyle";

export default function ParticipationCntFullPage () {

    const currentSubDomain = getCurrentSubDomain();
    const style = useCommonPageStyles()

    if(currentSubDomain === "nbt" || currentSubDomain.includes("toktokquiz") ){
        return <div className={style.nbt_root}>
            <Image alt={"success_icon"} src={successIcon}/>
            <div className={style.textStyle}>
                오늘 참여 가능한 미션 횟수를 초과하셨습니다!<br/>
                내일 다른 미션으로 찾아뵙겠습니다. 감사합니다.
            </div>
        </div>
    }
    else {
        return <Column gap={'16px'} alignItems={'center'} justifyContent={'center'}>
            <div style={{height: '96px'}}/>
            <AccessibilityErrorFilled fontSize={'200px'}/>
            <Row>
                오늘 참여 가능한 미션 횟수를 초과하셨습니다!
            </Row>
            <Row>
                내일 다른 미션으로 찾아뵙겠습니다. 감사합니다.
            </Row>
        </Column>
    }

}